import type { QuizAttemptPublic, QuizPublic } from '@repo/types/quiz';
import type { ComponentProps } from 'react';

import QuizBasicStats from '@/components/features/quizzes/QuizBasicStats';
import QuizStartAlertDialog from '@/components/features/quizzes/QuizStartAlertDialog';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useAssignedQuizzesData } from '@/hooks/quiz';
import { getAttemptBadgeMeta } from '@/utils/attempt-status';

interface QuizDetailHeaderProps {
  quiz: QuizPublic & { quizresps: QuizAttemptPublic[] };
  attempt?: QuizAttemptPublic;
}

export default function QuizDetailHeader(quizDetailHeaderProps: QuizDetailHeaderProps) {
  const { quiz, attempt } = quizDetailHeaderProps;
  const { state, actions } = useAssignedQuizzesData({
    enabledAssignedQuizzes: false,
  });

  return (
    <div className="bg-background flex w-full flex-col gap-4 rounded-2xl border p-4">
      <QuizStartAlertDialog onStateChange={actions.setStartDialog} state={state.startDialog} quiz={quiz} />
      <div className="flex flex-wrap justify-center gap-2 md:justify-start">
        <Badge variant={attempt ? getAttemptBadgeMeta(attempt).variant : 'destructive'}>{attempt ? getAttemptBadgeMeta(attempt).label : 'Nie ukończono'}</Badge>
      </div>
      <div className="space-y-1">
        <h1 className="text-center text-xl font-bold md:text-start">{quiz.name}</h1>
        <p className="text-font-semibold hidden text-sm md:block">{quiz.desc}</p>
      </div>

      <p className="block text-center md:hidden">{quiz.desc}</p>
      <div className="flex justify-between max-md:justify-center">
        <QuizBasicStats quiz={quiz} className="md:flex md:flex-row md:flex-wrap md:[&>div]:items-start" />
        <StartButton className="max-md:hidden" quiz={quiz} onClick={() => actions.startQuiz(quiz.id)} />
      </div>
      <StartButton className="md:hidden" quiz={quiz} onClick={() => actions.startQuiz(quiz.id)} />
    </div>
  );
}

interface StartButtonProps extends ComponentProps<typeof Button> {
  quiz: QuizPublic & { quizresps: QuizAttemptPublic[] };
}

function StartButton(startButtonProps: StartButtonProps) {
  const { quiz, onClick, ...props } = startButtonProps;
  if (quiz.maxAttempts === 0 || quiz.maxAttempts > quiz.quizresps.length) {
    return (
      <Button className="ml-auto" onClick={onClick} {...props}>
        Rozpocznij
      </Button>
    );
  }

  return null;
}
